import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

import { Notice } from '@cartwhl/ui/molecules/Notice';

import * as navigationStore from './navigationStore';

export type NoticeState = {
  notices: Notice[];
};

let noticeId = 1;

export const state = proxy<NoticeState>({
  notices: [],
});

if (
  process.env.NODE_ENV === 'development' &&
  typeof window !== 'undefined' &&
  '__REDUX_DEVTOOLS_EXTENSION__' in window
) {
  devtools(state, { name: 'Notices', enabled: true });
}

export const add = (
  type: Notice['type'],
  message: string,
  timeout: number,
  actionText?: string,
  onAction?: () => void,
  customIconName?: 'spinIcon' | 'noticeIcon',
  customBackgroundColor?: string,
  customTextColor?: string,
) => {
  state.notices.push({
    id: noticeId++,
    type,
    message,
    timeout,
    actionText,
    onAction,
    customIconName,
    customBackgroundColor,
    customTextColor,
  });
};

export const remove = (id: number) => {
  state.notices = state.notices.filter((notice) => notice.id !== id);
};

export const error = (message: string, timeout = 30000) => {
  add('error', message, timeout);
};

export const success = (message: string, timeout = 3250) => {
  add('success', message, timeout);
};

export const warning = (message: string, timeout = 7500) => {
  add('warning', message, timeout);
};

export const info = (message: string, timeout = 7500) => {
  add('info', message, timeout);
};

export const customAction = (
  message: string,
  actionText: string,
  onAction: () => void,
  timeout = 7500,
  customIconName: 'spinIcon' | 'noticeIcon',
  customBackgroundColor: string,
  customTextColor: string,
) => {
  add(
    'action',
    message,
    timeout,
    actionText,
    onAction,
    customIconName,
    customBackgroundColor,
    customTextColor,
  );
};

export const getMoreSpins = () => {
  customAction(
    "You're ready for more Spins!",
    'Get more',
    () => {
      navigationStore.setModal(navigationStore.CommonModalName.PURCHASE_SPINS);
    },
    15000,
    'spinIcon',
    'bg-yellow',
    'text-black',
  );
};
